// src/Monetization/UpgradeModal.js
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {usePlan, FEATURE_LABELS} from '../context/PlanContext';
import './UpgradeModal.css';

const FEATURE_ICONS = {
  chat: '💬',
  newChat: '💬',
  importText: '📝',
  importPhoto: '📷',
  audio: '🎙️',
  video: '🎬',
  aiRecipeChat: '🤖',
  photo: '📸',
};

const BLOCKED_LABEL = {
  chat:        '10 mensajes/mes en el plan Gratis',
  newChat:     'El plan Gratis solo permite 1 chat',
  audio:       'Solo 1 prueba de audio en el plan Gratis',
  video:       'Subir vídeos es exclusivo de Premium',
  aiRecipeChat:'El Chef IA en recetas es exclusivo de Premium',
  photo:       'El plan Gratis solo permite 1 foto por receta',
  importText:  '5 importaciones de texto/mes en el plan Gratis',
  importPhoto: '2 importaciones con foto/mes en el plan Gratis',
};

const COMPARISON = [
  { label: 'Chef IA en recetas', basic: '❌', premium: '✅' },
  { label: 'Chats simultáneos',  basic: '1',  premium: '∞' },
  { label: 'Mensajes/mes',       basic: '10', premium: '∞' },
  { label: 'Fotos por receta',   basic: '1',  premium: '5' },
  { label: 'Audio IA',           basic: '1 vez', premium: '∞' },
];

const UpgradeModal = () => {
  const {upgradeVisible, upgradeFeature, hideUpgradeModal} = usePlan();
  const navigate = useNavigate();

  if (!upgradeVisible) return null;

  const icon = FEATURE_ICONS[upgradeFeature] || '⭐';
  const featureLabel = FEATURE_LABELS[upgradeFeature] || 'esta función';
  const blockedLabel = BLOCKED_LABEL[upgradeFeature] || 'Has alcanzado el límite de tu plan actual';

  const handleUpgrade = () => {
    hideUpgradeModal();
    navigate('/pricing');
  };

  return (
    <div
      className="upgrade-overlay"
      role="dialog"
      aria-modal="true"
      onClick={hideUpgradeModal}
    >
      <div
        className="upgrade-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="upgrade-close"
          aria-label="Cerrar"
          onClick={hideUpgradeModal}
        >
          ×
        </button>

        <div className="upgrade-icon">{icon}</div>
        <h2 className="upgrade-title">Función Premium</h2>
        <p className="upgrade-feature-name">{featureLabel}</p>
        <p className="upgrade-blocked-msg">{blockedLabel}</p>

        {/* Plan comparison */}
        <div className="upgrade-comparison">
          <div className="upgrade-comparison-header">
            <span />
            <span className="upc-col upc-col--basic">Gratis</span>
            <span className="upc-col upc-col--premium">Premium ⭐</span>
          </div>
          {COMPARISON.map(row => (
            <div key={row.label} className="upgrade-comparison-row">
              <span className="upc-label">{row.label}</span>
              <span className="upc-col upc-col--basic">{row.basic}</span>
              <span className="upc-col upc-col--premium">{row.premium}</span>
            </div>
          ))}
        </div>

        <button className="upgrade-cta" onClick={handleUpgrade}>
          ✨ Comprar Premium — desde 4,99€/mes
        </button>
        <button className="upgrade-later" onClick={hideUpgradeModal}>
          Ahora no
        </button>
      </div>
    </div>
  );
};

export default UpgradeModal;
